<template>
  <div>
  <div class="record-box" v-for="(item, index) in audioList" :key="item.url">
    <div class="record-item pointer" @click="play(item)">
      <img src="@/assets/questionBank/record-play.png" class="record-icon" v-show="!item.isPlay" />
      <img src="@/assets/questionBank/record-pause.png" class="record-icon" v-show="item.isPlay" />
      <div :class="{ 'record-line ml6 mr5': true, 'record-animation': item.isPlay }">
        <div class="small"></div>
        <div class="medium"></div>
        <div class="large"></div>
        <div class="medium"></div>

        <div class="small"></div>
        <div class="medium"></div>
        <div class="large"></div>
        <div class="medium"></div>

        <div class="small"></div>
        <div class="medium"></div>
        <div class="large"></div>
        <div class="medium"></div>

        <div class="small"></div>
        <div class="medium"></div>
        <div class="large"></div>
        <div class="medium"></div>

        <div class="small"></div>
        <div class="medium"></div>
        <div class="large"></div>
        <div class="medium"></div>

        <div class="small"></div>
        <div class="medium"></div>
        <div class="large"></div>
        <div class="medium"></div>

        <div class="small"></div>
        <div class="medium"></div>
        <div class="large"></div>
        <div class="medium"></div>
      </div>
      <span class="record-second">{{ item.duration ? item.duration : 0 }}s'</span>
      <img src="@/assets/questionBank/record-close.png" class="record-icon ml8" v-if="isShowDel" @click.stop="del(index, item)" />
    </div>
  </div>
  </div>
</template>

<script>
import { Notification } from "element-ui";

// @ts-ignore
import { homeworkAudio } from "@/utils/public.js";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  name: 'RecordList',
  props: {
    // 是否显示删除按钮
    isShowDel: {
      type: Boolean,
      default: true,
    },
    // 列表
    list: {
      type: Array,
      default: () => [],
    },
    // 题目信息
    info: {
      type: Object,
      default: () => ({}),
    },
    // 是否正在录音
    isRecord: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      audioList: [],
      subjectId: 0,
    };
  },
  beforeDestroy() {
    homeworkAudio.stop();
  },
  watch: {
    list: {
      handler() {
        this.$nextTick(() => {
          if (this.subjectId != this.info.subjectId) {
            this.subjectId = this.info.subjectId;
            this.audioList = [];
          }
          for (let i = 0; i < this.list.length; i++) {
            const index = this.audioList.findIndex((x) => x.url == this.list[i]);
            if (index == -1) {
              this.audioList.push({
                url: this.list[i],
                isPlay: false,
                duration: 0,
              });
              this.countAudioTime(this.list[i]).then((duration) => {
                this.audioList[i].duration = duration;
              });
            }
          }
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 计算音频的时长
    countAudioTime(url) {
      return new Promise(async (resolve) => {
        const audio = new Audio();
        audio.src = url;
        while (isNaN(audio.duration) || audio.duration === Infinity) {
          // 延迟一会 不然网页都卡死
          await new Promise((resolve) => setTimeout(resolve, 200));
          // 设置随机播放时间，模拟调进度条
          audio.currentTime = 10000000 * Math.random();
        }
        resolve(Math.ceil(audio.duration));
      });
    },
    play(item) {
      if (this.isRecord) {
        Notification.closeAll();
        Notification({
          title: "提示",
          message: "请先结束录音",
          type: "warning",
          duration: 2000,
          zIndex: 2100,
        });
        return;
      }
      homeworkAudio.play(item);
    },
    // 删除
    del(index, item) {
      if (item.isPlay) {
        homeworkAudio.stop();
      }
      setTimeout(() => {
        this.audioList.splice(index, 1);
        this.$emit("del", index);
      }, 10);
    },
    // 查询是否有正在播放的音频
    isPlay() {
      return this.audioList.some((i) => i.isPlay);
    },
    // 停止正在播放的音频
    stopPlay() {
      homeworkAudio.stop();
    },
  },
};
</script>

<style lang="scss" scoped>
.record-box {
  display: inline-block;
  margin-right: 12px;
  margin-bottom: 12px;
}
.record-item {
  display: inline-flex;
  align-items: center;
  height: 30px;
  border-radius: 15px;
  background-color: #ecf1ff;
  padding: 0 14px;
  .record-icon {
    width: 15px;
    height: 15px;
  }
  .record-line {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    div {
      width: 2px;
      background-color: #3366ff;
      margin-right: 3px;
    }
    .small {
      height: 5px;
    }
    .medium {
      height: 9px;
    }
    .large {
      height: 13px;
    }
  }
  .record-animation {
    .small {
      animation: smallLine 1s linear infinite;
    }
    .medium {
      animation: mediumLine 1s linear infinite;
    }
    .large {
      animation: largeLine 1s linear infinite;
    }
  }
  .record-second {
    min-width: 35px;
    font-size: 14px;
    color: #3366ff;
  }
}
@keyframes smallLine {
  0% {
    height: 5px;
  }
  50% {
    height: 13px;
  }
  100% {
    height: 5px;
  }
}
@keyframes mediumLine {
  0% {
    height: 9px;
  }
  33% {
    height: 13px;
  }
  66% {
    height: 5px;
  }
  100% {
    height: 9px;
  }
}
@keyframes largeLine {
  0% {
    height: 13px;
  }
  50% {
    height: 5px;
  }
  100% {
    height: 13px;
  }
}
</style>
